import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    radio:
      'group relative flex w-full cursor-pointer items-center px-3 py-4 transition-colors duration-200 before:pointer-events-none before:absolute before:inset-0 before:border before:border-black before:opacity-0 before:transition-opacity before:duration-200',
    radioInner:
      'flex size-6 shrink-0 items-center justify-center rounded-full border border-black transition-colors duration-200 group-hover:border-black focus:outline-none',
    label: 'heading-m cursor-pointer pl-3 transition-colors duration-200',
    dot: 'size-4.5 rounded-full bg-black opacity-0 transition-opacity duration-200'
  },
  variants: {
    checked: {
      true: {
        radio: 'bg-base before:opacity-100',
        dot: 'opacity-100'
      },
      false: {
        radio: 'bg-surface'
      }
    },
    disabled: {
      true: {
        label: 'text-tertiary group-hover:text-tertiary cursor-not-allowed',
        radioInner:
          'border-tertiary data-checked:border-tertiary group-hover:border-tertiary cursor-not-allowed',
        dot: 'bg-tertiary'
      }
    }
  },
  defaultVariants: {
    checked: false
  }
});
